<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <!-- track -->
    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a
            class="linkstyle"
            href="https://www.chanchao.com.tw/ExhibitorServiceTW/en"
            >Exhibition List</a
          >
          <span>/</span> <em name="Exhibition">{{ ExhibitionName }}</em
          ><span>/</span><span name="homeDirectoryTitleEn"></span>
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->

    <div class="MbDevice">
      <div class="homeLeft mt-5">
        <div class="UserAccount ml-1">
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
        <hr />
        <p class="my-3">&nbsp;</p>

        <div class="expoLogo">
          <div class="imgCorp squareThumb">
            <img :src="ExhLogo" width="100%" />
          </div>
        </div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition">{{ ExhibitionName }}</p>
          <p>{{ Exhdate }}</p>
          <p>{{ eExhVenue }}</p>
        </div>

        <p class="clear"></p>
      </div>
    </div>

    <div class="articleEn">
      <div class="contentBox">
        <h1><span name="homeDirectoryTitleEn"></span></h1>
        <p class="my-3">&nbsp;</p>

        <div v-if="openDirectory == '0'">
          <div class="alert" style="font-size: 15px">
            Show directory function is unavailable.
          </div>
        </div>

        <div v-else-if="openDirectory == '1'">
          <!-- 未截止表單形式 -->

          <div class="alert">
            <div class="HasDirectory">
              <p>
                Please complete your show directory before<span class="red">
                  {{ directoryListDeadline }} </span
                >. We will publish your information in the exhibition show
                directory. Failure to complete will not be published. If you
                need to modify company name, telephone, fax,<a
                  href="//www.chanchao.com.tw/en/contact.asp"
                  target="_blank"
                >
                  please contact the organizer</a
                >.
              </p>
            </div>
            <p class="mt-1">
              The following content (Company Name, Website and Company/Product
              Intro.) will be shown on the official website > Exhibitor List.
            </p>
          </div>
          <p class="my-3">&nbsp;</p>
          <form
            name="thisform"
            id="form"
            class="mx-3"
            v-if="!dateExpired"
            @submit.prevent="submitform"
          >
            <input type="hidden" name="RegNo" />
            <!-- 未登錄且有歷史資料則顯示按鈕 -->
            <div id="HistoryDir" v-if="!analLogin && analHistory" class="mb-5">
              <button
                class="mr-2 mb-1 btn btn-primary"
                @click.prevent="getHistData"
              >
                Import</button
              >You have historical data, please click historical data to import.
              <p class="red mt-2" v-if="alertSubmit">
                *Please confirm the data you selected is correct, and press the
                confirm button to complete the upload.
              </p>
            </div>
            <h3 name="Directory_ComName">{{ Directory_ComName }}</h3>
            <input type="hidden" name="ComName" />
            <p name="Directory_eComName">{{ Directory_eComName }}</p>
            <input type="hidden" name="eComName" />
            <p class="divider"></p>

            <div class="my-2">
              <p class="formTitle">Tel</p>
              <p>{{ RegTel }}</p>
              <p v-if="RegFax" class="formTitle mt-2">Fax</p>
              <p>{{ RegFax }}</p>
            </div>

            <p class="my-3">&nbsp;</p>

            <p class="formTitle">Postcode <span class="red">*</span></p>
            <input
              type="text"
              name="ComPostalcode"
              v-model="directoryList.ComPostalcode"
              class="codeText textStyle"
              maxlength="10"
              required
            />
            <p class="my-3">&nbsp;</p>

            <p class="formTitle">Address <span class="red">*</span></p>

            <div class="langTip">
              <input
                type="text"
                name="eComAddress"
                v-model="directoryList.eComAddress"
                class="maxText textStyle"
                maxlength="200"
                required
              />
              <span>EN</span>
            </div>
            <p class="divider"></p>
            <div class="langTip">
              <input
                type="text"
                name="ComAddress"
                v-model="directoryList.ComAddress"
                class="maxText textStyle"
                maxlength="200"
                required
              />
              <span>中</span>
            </div>

            <p class="my-3">&nbsp;</p>
            <div class="left">
              <p class="formTitle">Email <span class="red">*</span></p>
              <input
                type="text"
                name="ComEmail"
                v-model="directoryList.ComEmail"
                class="maxText textStyle"
                maxlength="100"
                required
              />

              <p class="grayBG mt-2">
                If you are submitting multiple emails, please add semicolon(;)
                to separate each email, ex.
                chanchao@gmail.com;exhibitorTW@gmail.com
              </p>
              {{ anaText }}
              <div v-if="alertMail">
                <span style="font-size: 13px; color: #e42212"
                  >Email contains special character.</span
                >
              </div>
            </div>

            <div class="right">
              <p class="formTitle">Website</p>
              <input
                type="text"
                name="ComWebsite"
                v-model="directoryList.ComWebsite"
                class="maxText textStyle"
                maxlength="100"
              />
              <p class="grayBG mt-2">
                The website provided here must contain http or https, or the
                link may not be working.
              </p>
            </div>
            <p class="clear">&nbsp;</p>
            <p class="my-3">&nbsp;</p>

            <p class="formTitle">
              Company/Product Intro. (EN) <span class="red">*</span>
            </p>
            <div>
              <textarea
                name="eProduct"
                rows="8"
                class="maxText textStyle"
                v-model="directoryList.eProduct"
                @input="ecountNums"
                required
                placeholder="English"
              ></textarea>
              <p class="divider"></p>

              <p class="blueBG" v-if="enWdNum">
                Max. {{ eDirectoryProductLimit }} characters<span
                  v-if="eExtraWdNum !== 0"
                >
                  <span>, and {{ eExtraWdNum }} characters remaining </span>
                </span>
              </p>
              <p class="redBG" v-else>
                *Max. {{ eDirectoryProductLimit }} characters, Exceeded
                {{ eExtraWdNum }} characters
              </p>
            </div>
            <p class="my-3">&nbsp;</p>
            <p class="formTitle">
              Company/Product Intro. (CN) <span class="red">*</span>
            </p>
            <div>
              <textarea
                name="Product"
                rows="8"
                class="maxText textStyle"
                v-model="directoryList.Product"
                @input="countNums"
                required
                placeholder="中文"
              ></textarea>
              <p class="divider"></p>

              <p class="blueBG" v-if="cnWdNum">
                Max. {{ DirectoryProductLimit }} characters<span
                  v-if="ExtraWdNum !== 0"
                >
                  <span>, and {{ ExtraWdNum }} characters remaining </span>
                </span>
              </p>
              <p class="redBG" v-else>
                *Max. {{ DirectoryProductLimit }} characters, Exceeded
                {{ ExtraWdNum }} characters
              </p>
            </div>
            <p class="my-3">&nbsp;</p>
            <div class="text-center">
              <input type="submit" value="Submit" class="btnStyle" />
            </div>
          </form>

          <!-- 截止後形式 -->
          <div v-if="dateExpired" class="mx-4">
            <p class="formTitle mb-2">Company Name</p>
            <p>{{ directoryList.Directory_ComName }}</p>
            <p>{{ directoryList.Directory_eComName }}</p>
            <p class="my-3">&nbsp;</p>

            <div>
              <p class="formTitle">Tel</p>
              <p>{{ directoryList.ComTel }}</p>
            </div>
            <p class="my-3">&nbsp;</p>

            <div>
              <p v-if="directoryList.ComFax" class="formTitle mt-2">Fax</p>
              <p>{{ directoryList.ComFax }}</p>
            </div>

            <p class="my-3">&nbsp;</p>

            <div>
              <p class="formTitle">Postcode <span class="red">*</span></p>
              <p>{{ directoryList.ComPostalcode }}</p>
            </div>

            <p class="my-3">&nbsp;</p>
            <div class="mb-2">
              <p class="formTitle">Address <span class="red">*</span></p>
              <div class="langTip">
                {{ directoryList.ComAddress }}
              </div>
              <div class="langTip">
                {{ directoryList.eComAddress }}
              </div>
            </div>

            <p class="my-3">&nbsp;</p>
            <div class="mb-2">
              <div class="left">
                <p class="formTitle">Email <span class="red">*</span></p>
                <ul v-for="item in directoryEmail">
                  <li>{{ item }}</li>
                </ul>
              </div>
              <div class="right">
                <p class="formTitle">Website</p>
                {{ directoryList.ComWebsite }}
              </div>
            </div>

            <p class="clear">&nbsp;</p>
            <p class="my-3">&nbsp;</p>
            <p class="formTitle mt-2">
              Company/Product Intro. (CN) <span class="red">*</span>
            </p>
            <div>
              {{ directoryList.Product }}
            </div>
            <p class="my-3">&nbsp;</p>
            <p class="formTitle mt-2">
              Company/Product Intro. (EN) <span class="red">*</span>
            </p>
            <div>
              {{ directoryList.eProduct }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: `Directory Entry - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      Currentdate: "",
      directoryList: [],
      directoryEmail: [],
      directoryHistoryList: [],
      directoryListDeadline: "",
      DirectoryProductLimit: 0,
      eDirectoryProductLimit: 0,
      analLogin: false, //登錄狀態
      analHistory: false, //歷史登錄狀態
      alertSubmit: false,
      dateExpired: false,

      Directory_ComName: "",
      Directory_eComName: "",
      RegFax: "",
      RegTel: "",

      ExtraWdNum: 0, //剩餘產品字數
      eExtraWdNum: 0,

      alertMail: false,
      lang: "en",
      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",

      openDirectory: "",

      cnWdNum: true,
      enWdNum: true,

      ExtrawordLeng: "",
      ExhibitionName: "",
      UserId: "",

      DirectoryHardcopy: false,
      DirectoryHardcopyNO: 1,
    };
  },

  computed: {
    anaText() {
      const vm = this;

      if (vm.directoryList.ComEmail) {
        let pattern = new RegExp(
          "[`+~!#$^&*()=|{}':',\\[\\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？%]"
        );
        let analEmail = vm.directoryList.ComEmail.match(pattern);

        if (analEmail) {
          vm.alertMail = true;
        } else {
          vm.alertMail = false;
        }
      }
    },
  },

  methods: {
    getHistData() {
      const vm = this;
      vm.directoryList = vm.directoryHistoryList;

      if (vm.lang == "tw") {
        alert("請確認帶入的歷史資料無誤，並按下確定送出按鈕才算完成登錄。");
      } else {
        alert(
          "Please confirm the historical data you selected is correct, and press the confirm button to complete the upload."
        );
      }
      vm.alertSubmit = true;

      let inputleng =
        vm.DirectoryProductLimit - vm.directoryList.Product.length;
      if (inputleng >= 0) {
        this.cnWdNum = true;
        vm.ExtraWdNum = inputleng;
      } else {
        this.cnWdNum = false;
        this.ExtraWdNum = Math.abs(inputleng);
      }

      let eInputleng =
        vm.eDirectoryProductLimit - vm.directoryList.eProduct.length;

      if (eInputleng >= 0) {
        this.enWdNum = true;
        vm.eExtraWdNum = eInputleng;
      } else {
        this.enWdNum = false;
        this.eExtraWdNum = Math.abs(eInputleng);
      }
    },

    submitform() {
      const vm = this;

      let pattern = new RegExp(
        "[`+~!#$^&*()=|{}':',\\[\\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？%]"
      );
      let analEmail = vm.directoryList.ComEmail.match(pattern);

      if (!analEmail) {
        const info = {
          CSRF: vm.CSRF_Token,
          RegNo: vm.RegNo,
          ComName: vm.Directory_ComName,
          eComName: vm.Directory_eComName,
          ComPostalCode: vm.directoryList.ComPostalcode,
          ComAddress: vm.directoryList.ComAddress,
          eComAddress: vm.directoryList.eComAddress,
          ComTel: vm.RegTel,
          ComFax: vm.RegFax,
          ComEmail: vm.directoryList.ComEmail,
          ComWebsite: vm.directoryList.ComWebsite,
          Product: vm.directoryList.Product,
          eProduct: vm.directoryList.eProduct,
        };
        // console.log(info)

        if (vm.lang == "tw") {
          if (
            !vm.directoryList.ComPostalcode ||
            !vm.directoryList.ComAddress ||
            !vm.directoryList.ComEmail ||
            !vm.directoryList.Product ||
            !vm.directoryList.eProduct ||
            !vm.directoryList.eComAddress ||
            !vm.cnWdNum ||
            !vm.enWdNum
          ) {
            alert("您輸入的欄位內容需填寫完整並符合規範，請再次檢查！");
          } else {
            const url = `/apiExhibitors/Directory/${this.DirectoryHardcopyNO}`;
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert("您已完成會刊登錄！");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/directory?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("系統忙碌，請稍後再試！");
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`;
              } else if (response.data.Code == 253) {
                alert("廠商/產品介紹長度不可超過 500 字數！");
              } else if (response.data.Code == 254) {
                alert("登錄已截止！");
              } else if (response.data.Code == 255) {
                alert("您輸入的Email錯誤，請重新檢查！");
              }
            });
          }
        } else {
          if (
            !vm.directoryList.ComPostalcode ||
            !vm.directoryList.ComAddress ||
            !vm.directoryList.ComEmail ||
            !vm.directoryList.Product ||
            !vm.directoryList.eProduct ||
            !vm.directoryList.eComAddress ||
            !vm.cnWdNum ||
            !vm.enWdNum
          ) {
            alert("There are incomplete fields, please check again.");
          } else {
            const url = `/apiExhibitors/Directory/${this.DirectoryHardcopyNO}`;
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert("You have completed the show directory.");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/directory?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("System is busy, please try again later.");
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`;
              } else if (response.data.Code == 253) {
                alert("Company/Product description within 500 words.");
              } else if (response.data.Code == 254) {
                alert("The directory is closed.");
              } else if (response.data.Code == 255) {
                alert("Invalid email, please check again.");
              }
            });
          }
        }
      } else {
        if (vm.lang == "tw") {
          alert("Email欄位含有特殊字元，請重新檢查！");
        } else {
          alert("Email contains special character, please check again.");
        }
      }
    },

    countNums() {
      const vm = this;

      var txtVal = this.directoryList.Product.len();
      var AnalVal = vm.DirectoryProductLimit - txtVal;
      if (AnalVal >= 0) {
        this.cnWdNum = true;
        this.ExtraWdNum = AnalVal;
      } else {
        this.cnWdNum = false;
        this.ExtraWdNum = Math.abs(AnalVal);
      }
    },

    ecountNums() {
      const vm = this;

      var etxtVal = this.directoryList.eProduct.len();
      var eAnalVal = vm.eDirectoryProductLimit - etxtVal;

      if (eAnalVal >= 0) {
        this.enWdNum = true;
        this.eExtraWdNum = eAnalVal;
      } else {
        this.enWdNum = false;
        this.eExtraWdNum = Math.abs(eAnalVal);
      }
    },
  },

  created() {
    const vm = this;

    // $('meta[name="description"]').attr('content', newDescription)

    String.prototype.len = function () {
      return this.replace(/[^\x00-\xff]/g, "rr").length;
    };

    //語系會自動抓html lang tag

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    // axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
    //   vm.UserId = response.data
    // })

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    //取得當前時間
    let theDate = new Date();
    vm.Currentdate = `${theDate.getFullYear()}/${
      theDate.getMonth() + 1
    }/${theDate.getDate()}`;

    //參展商基本資料
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Directory/${vm.RegNo}`)
      .then((response) => {
        // console.log(response.data)

        vm.Directory_ComName = response.data.Data.ComName;
        vm.Directory_eComName = response.data.Data.eComName;
        vm.RegFax = response.data.Data.ComFax;
        vm.RegTel = response.data.Data.ComTel;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}/?lang=${vm.lang}`
      )
      .then((response) => {
        // console.log(response.data)
        vm.directoryListDeadline = response.data.Data.DirectoryDeadline;
        vm.DirectoryProductLimit = response.data.Data.DirectoryProductLimit;
        vm.eDirectoryProductLimit = response.data.Data.eDirectoryProductLimit;
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
        vm.openDirectory = response.data.Data.DirectoryArchived;
        vm.ExhibitionName = response.data.Data.Exhibition;

        if (response.data.Data.DirectoryHardcopy == 1) {
          vm.DirectoryHardcopy = false;
          vm.DirectoryHardcopyNO = 1;
          $('[name="directoryTitle"]').text("會刊登錄");
          $('[name="directoryTitleEn"]').text("Directory Entry");
          $('[name="profileTitleEn"]').text("Basic Information");
          $('[name="homeCompanyInfo"]').text("基本資料");
          $('[name="homeDirectoryTitle"]').text("會刊登錄");
          $('[name="homeDirectoryTitleEn"]').text("Directory Entry");
          $(".HasDirectory").addClass("show");
          $(".NoDirectory").addClass("hide");
          if (vm.lang == "tw") {
            $("title").html("會刊登錄 - 展昭參展商管理系統");
          } else {
            $("title").html(
              `Directory Entry - Chan Chao Exhibitor's Online Service System`
            );
          }
        } else {
          vm.DirectoryHardcopy = true;
          vm.DirectoryHardcopyNO = 0;

          $('[name="directoryTitle"]').text("廠商介紹");
          $('[name="directoryTitleEn"]').text("Exhibitor Profile");
          $('[name="profileTitleEn"]').text("Basic Information");
          $('[name="homeCompanyInfo"]').text("基本資料");
          $('[name="homeDirectoryTitle"]').text("廠商介紹");
          $('[name="homeDirectoryTitleEn"]').text("Exhibitor Profile");
          $(".HasDirectory").addClass("hide");
          $(".NoDirectory").addClass("show");
          if (vm.lang == "tw") {
            $("title").html("廠商介紹 - 展昭參展商管理系統");
          } else {
            $("title").html(
              `Exhibitor Profile - Chan Chao Exhibitor's Online Service System`
            );
          }
        }

        //判定登錄期限狀態
        //定義dateExpired是截止，當TRUE就是已截止，FALSE是未截止
        //如何沒有紙本(會刊登錄)才有截止日的限制

        if (!vm.DirectoryHardcopy) {
          if (
            Date.parse(vm.Currentdate).valueOf() >
            Date.parse(vm.directoryListDeadline).valueOf()
          ) {
            vm.dateExpired = true; //截止
            // console.log(vm.dateExpired)
          } else {
            vm.dateExpired = false; //未截止
            // console.log(vm.dateExpired)
          }
        }

        //判斷是否登錄，若無就取得歷史紀錄

        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/Directory/${vm.RegNo}`
          )
          .then((response) => {
            if (response.data.Data.Product) {
              vm.directoryList = response.data.Data;
              vm.directoryEmail = response.data.Data.ComEmail.split(";");

              let ExtraLeng =
                vm.DirectoryProductLimit - response.data.Data.Product.len();

              if (ExtraLeng >= 0) {
                this.cnWdNum = true;
                vm.ExtraWdNum = ExtraLeng;
              } else {
                this.cnWdNum = false;
                this.ExtraWdNum = Math.abs(ExtraLeng);
              }

              let eExtraLeng =
                vm.eDirectoryProductLimit - response.data.Data.eProduct.len();

              if (eExtraLeng >= 0) {
                this.enWdNum = true;
                vm.eExtraWdNum = eExtraLeng;
              } else {
                this.enWdNum = false;
                this.eExtraWdNum = Math.abs(eExtraLeng);
              }

              vm.analLogin = true;
            } else {
              vm.analLogin = false;
              axios
                .get(
                  `https://www.chanchao.com.tw/apiExhibitors/Directory/${vm.RegNo}?prev=1`
                )
                .then((response) => {
                  if (response.data.Code == 200) {
                    vm.analHistory = true;
                    vm.directoryHistoryList = response.data.Data;
                  } else {
                    vm.analHistory = false;
                  }
                });
            }
          });

        axios
          .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
          .then((response) => {
            vm.UserId = response.data;
          });
      });

    $(document).ready(function () {
      $(".HasDirectory").addClass("hide");
    });
  },
};
</script>

<style lang="scss">
.grayBG {
  background: #f0f4f5;
  color: #333;
  padding: 5px 10px;
  display: inline-block;
  word-break: break-all;
  font-size: 14px;
}

.hide {
  display: none;
}

.show {
  display: block;
}
</style>
